// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading_loadingWrapper__2kTxN"};